import React from 'react'
import { useLocation } from 'react-router-dom'
import { Header } from '../Header';

const Lobby = () => {
    const location= useLocation();
    const gameUrl= location.state;
    console.log(gameUrl);

  return (
    <div>
     {gameUrl && (
      <iframe
        src={gameUrl}
        width="100%"
        title="Game Frame"
        style={{ border: 'none',height:'100vh' }}
      />
    )}
    </div>
  )
}

export default Lobby
